<template>

  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.DOCUMENT }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :initial-values="form"
              :validation-schema="schema">
          <div class="input__group input__add__info">
            <label for="doc-type-input" class="label">{{ $lang.app.DOCUMENT_TYPE }} <span class="text-red-500">*</span></label>
            <div class="select__wrapper">
              <Field name="docType" v-slot="{ field, errorMessage }">
                <Multiselect
                    id="doc-type-input"
                    :class="{'select--fail': errorMessage }"
                    v-bind="field"
                    v-model="form.docType"
                    :options="documentTypes"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND"
                    :can-clear="false">
                </Multiselect>
                <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
              </Field>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="surname-input" class="label">{{ $lang.app.EXECUTOR_SURNAME }}</label>
                <Field name="surname" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="surname-input"
                         v-model="form.surname"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="name-input" class="label">{{ $lang.app.EXECUTOR_NAME }}</label>
                <Field name="name" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="name-input"
                         v-model="form.name"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="patronymic-input" class="label">{{ $lang.app.EXECUTOR_PATRONYMIC }}</label>
                <Field name="patronymic" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="patronymic-input"
                         v-model="form.patronymic"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="certificate-no-input" class="label">{{ $lang.app.CERTIFICATE_NUMBER }}</label>
                <Field name="certificateNo" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="certificate-no-input"
                         v-model="form.certificateNo"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.UPDATE }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import * as yup from "yup";
import {Field, Form} from 'vee-validate';
import applicationApi from "@/api/applicant/application";
import documentTypeApi from "@/api/ref/documentType";

export default {
  name: 'ApplicantApplicationDocumentsVersionEditModal',
  components: {
    Field,
    Form,
  },
  data() {
    return {
      showModal: false,

      submitting: false,

      documentTypes: [],

      documentsVersion: null,
      document: null,

      form: null,

      schema: yup.object({
        docType: yup.mixed().required(),
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-applicant-application-document-version-edit-modal', (payload) => {
      this.getDocumentTypes()
      this.documentsVersion = payload.documentsVersion
      this.document = payload.document
      this.form = {
        docType: payload.document.docType?.id,
        surname: payload.document.surname,
        name: payload.document.name,
        patronymic: payload.document.patronymic,
        certificateNo: payload.document.certificateNo,
      }

      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-applicant-application-document-version-edit-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    getDocumentTypes() {
      documentTypeApi.getDocumentTypes()
          .then(response => {
            this.documentTypes = response.map(el => {
              return {value: el.id, label: el.name}
            })
          }).catch(error => {
        console.log(error);
      })
    },

    submit(values, actions) {
      this.submitting = true
      applicationApi.updateDocument(this.$route.params.applicationId, this.document.id, {
        docType: this.form.docType,
        surname: this.form.surname,
        name: this.form.name,
        patronymic: this.form.patronymic,
        certificateNo: this.form.certificateNo,
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
            this.submitting = false
      })
    }
  }
}
</script>
